export const ExpectedResponseLevel = [
    {
        value: 0,
        description: 'Not Set',
    },
    {
        value: 1,
        description: 'Issue Level',
    },
    {
        value: 2,
        description: 'Group Level',
    },
    {
        value: 3,
        description: 'Item Level',
    },
]

export default ExpectedResponseLevel